export const UPDATE_PROGRAM = "UPDATE_PROGRAM";
export const UPDATE_INSURED_NAME = "UPDATE_INSURED_NAME";
export const UPDATE_RISK_DESCRIPTION = "UPDATE_RISK_DESCRIPTION";
export const UPDATE_INCEPTION = "UPDATE_INCEPTION";
export const UPDATE_REFERENCE = "UPDATE_REFERENCE";
export const UPDATE_WHETHER_IN_US = "UPDATE_WHETHER_IN_US";
export const UPDATE_TURNOVER = "UPDATE_TURNOVER";
export const UPDATE_INDUSTRY_CLASS = "UPDATE_INDUSTRY_CLASS";
export const UPDATE_BROKERAGE = "UPDATE_BROKERAGE";
export const UPDATE_REQUESTED_BROKERAGE = "UPDATE_REQUESTED_BROKERAGE";
export const UPDATE_PROFIT = "UPDATE_PROFIT";
export const UPDATE_EXPENSES = "UPDATE_EXPENSES";
export const UPDATE_EXPIRATION = "UPDATE_EXPIRATION";
export const UPDATE_PRO_RATA_ADJUSTMENT = "UPDATE_PRO_RATA_ADJUSTMENT";
export const UPDATE_OTHER_ACQUISITION_COSTS = "UPDATE_OTHER_ACQUISITION_COSTS";
export const UPDATE_INSURED_ADDRESS = "UPDATE_INSURED_ADDRESS";
export const UPDATE_MAILING_ADDRESS = "UPDATE_MAILING_ADDRESS";
export const UPDATE_PRIOR_SUBMISSION = "UPDATE_PRIOR_SUBMISSION";
export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const UPDATE_REASSURED = "UPDATE_REASSURED";
export const UPDATE_PAYMENT_TERMS = "UPDATE_PAYMENT_TERMS";
export const ADD_DUNS = "ADD_DUNS";
export const REMOVE_DUNS = "REMOVE_DUNS";
export const CLEAR_COMPANY_NAICS = "CLEAR_COMPANY_NAICS";
export const SET_COMPANY_NAICS = "SET_COMPANY_NAICS";
export const SET_DERIVED_NAICS = "SET_DERIVED_NAICS";
export const UPDATE_PROGRAM_NOTES = "UPDATE_PROGRAM_NOTES";
export const UPDATE_RISK_SUMMARY = "UPDATE_RISK_SUMMARY";
export const UPDATE_DATA_QUALITY = "UPDATE_DATA_QUALITY";
export const UPDATE_MODEL = "UPDATE_MODEL";
export const UPDATE_STATE_OF_FILING = "UPDATE_STATE_OF_FILING";
export const UPDATE_INSURED_ADDRESS_COMPONENTS =
  "UPDATE_INSURED_ADDRESS_COMPONENTS";
export const UPDATE_SURPLUS_LINES_TAX_REPORTING =
  "UPDATE_SURPLUS_LINES_TAX_REPORTING";
export const SEED_SURPLUS_LINES_TAX_REPORTING =
  "SEED_SURPLUS_LINES_TAX_REPORTING";
export const UPDATE_AUTO_EXPOSURE_RATING = "UPDATE_AUTO_EXPOSURE_RATING";
export const UPDATE_LOSS_RATING = "UPDATE_LOSS_RATING";
export const UPDATE_LOSS_RATING_YEAR = "UPDATE_LOSS_RATING_YEAR";
export const UPDATE_AUTO_LOSS_RATING = "UPDATE_AUTO_LOSS_RATING";
export const UPDATE_EXPERIENCE_RATING = "UPDATE_EXPERIENCE_RATING";
export const UPDATE_XS_RATING = "UPDATE_XS_RATING";
export const UPDATE_RENEWAL_RATE_CHANGE = "UPDATE_RENEWAL_RATE_CHANGE";
export const SET_AUTO_PRICING_RESULT = "SET_AUTO_PRICING_RESULT";
export const SET_LOSS_RATING_RESULT = "SET_LOSS_RATING_RESULT";
export const SET_AUTO_LOSS_RATING_RESULT = "SET_AUTO_LOSS_RATING_RESULT";
export const SET_EXPERIENCE_RATING_RESULT = "SET_EXPERIENCE_RATING_RESULT";
export const SET_XS_RATING_RESULT = "SET_XS_RATING_RESULT";
export const SET_XS_RATING_AUTO_CALCULATE = "SET_XS_RATING_AUTO_CALCULATE";
export const UPDATE_CESSION = "UPDATE_CESSION";
